var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_3" }, [
    _c("div", { staticClass: "top clear" }, [
      _c("div", { staticClass: "img_box fl" }, [
        _c("img", { ref: "img", attrs: { src: _vm.data.src } })
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "title bold fl",
        domProps: { innerHTML: _vm._s(_vm.data.title) }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "border" }),
    _vm._v(" "),
    _vm.data.text
      ? _c("div", {
          staticClass: "text",
          domProps: { innerHTML: _vm._s(_vm.data.text) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.bol
      ? _c(
          "div",
          { staticClass: "topic" },
          _vm._l(_vm.list, function(item, index) {
            return _vm.update
              ? _c(
                  "div",
                  {
                    key: JSON.stringify(item.questionId) + index,
                    staticClass: "topic_list"
                  },
                  [
                    _c("Topic", {
                      ref: item.questionId,
                      refInFor: true,
                      attrs: {
                        disabledBol: _vm.disabledBol,
                        data: item,
                        topicList: _vm.topicList
                      },
                      on: { getTopic: _vm.getTopic }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-80cc96b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-80cc96b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_3.vue
// module id = null
// module chunks = 